<template>
  <div>
    <div class="headerButtons">
      <div class="headerButtons__backButton">
        <b-button variant="outline-primary" @click="$router.go(-1)">
            Назад
        </b-button>
      </div>
    </div>
    <div class="studentsProgress">
      <!-- Заголовок -->
      <div class="studentsProgress__title">
        <h3>
          <em class="fas fa-tasks"></em>
          Результаты занятий в группе
        </h3>
      </div>
      <!-- Фильтры -->
      <div class="studentsProgress__filters">
        <b-form-select
          v-model="selectedOrg"
          :options="optionsOrg"
          v-b-tooltip.hover
          title="Организация"
          class="mt-2 studentsProgress__filters-organisation"
          @change="onSortChanged"
        >
        </b-form-select>
        <b-form-select
          v-model="selectedClass"
          :options="optionsClass"
          v-b-tooltip.hover
          title="Класс"
          class="mt-2 studentsProgress__filters-class"
          @change="onSortChanged"
        >
        </b-form-select>
        <div class="studentsProgress__filters-date">
          <div class="studentsProgress__filters-date__range">
            <div style="flex: 1;" class="studentsProgress__filters-date__range__text">
              Период занятий:
            </div>
            <VueCtkDateTimePicker
              range
              noButton
              autoClose
              input-size
              class="mt-0"
              style="flex: 4;"
              color="#0078c1"
              button-color="#0078c1"
              format="DD.MM.YYYY"
              label="Выберите временной промежуток"
              v-model="dateRange"
              :custom-shortcuts="shortcuts"
              @input="onFilterChanged"
            />
          </div>
          <div class="studentsProgress__filters-date__btn">
            <b-button @click="resetFilters" variant="primary">
              Сброс
            </b-button>
          </div>
        </div>
      </div>
      <!-- Таблица -->
      <div class="studentsProgress__table" ref="gridDiv">
        <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-material ag-grid-vue-progress"
          rowHeight="78"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="simulatorMarks"
          :suppressPaginationPanel="true"
          :frameworkComponents="frameworkComponents"
          :context="context"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @filterChanged="onFilterChanged"
          @sortChanged="onSortChanged"
        >
        </ag-grid-vue>
      </div>
      <b-row class="mt-1 mb-5">
        <b-col class="col-12">
          <paginator class="studentsProgress__table__paginator"
            :pages="pages"
            :currentPage="currentPage"
            :pageSize="paginationPageSize"
            :total="total"
            :itemsCount="simulatorMarks.length"
            @toFirstPage="onToFirstPage"
            @toLastPage="onToLastPage"
            @previousPage="onPreviousPage"
            @nextPage="onNextPage"
          />
        </b-col>
      </b-row>
    </div>
    <training-report-modal />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash'
import moment from 'moment'
import { AgGridVue } from 'ag-grid-vue'

import { mapMutations, mapActions, mapGetters } from 'vuex'

import TrainingReportRenderer from '@/components/helpers/renderers/TrainingReportRenderer'

import TrainingReportModal from '@/components/content/education/training/modals/TrainingReportModal.vue'

import Paginator from '@/components/helpers/Paginator.vue'

import DateRangeFilter from '@/components/helpers/filters/DateRangeFilter'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

function nameFormatter(params) {
  return `${params.data.user.surname} ${params.data.user.name.slice(0, 1)}. ${params.data.user.midname.slice(0, 1)}.`
}

function dateFormatter(params) {
  return moment(params.data.trainingSession.createdAt).local().format('D.M.Y H:mm:ss')
}

function classFormatter(params) {
  return params.data.user.studentProfile.class
}

function stagesFormatter(params) {
  return params.data.trainingSession.stages
}

function notComparator() {
  return null
}

export default {
  name: 'GroupReport',
  components: {
    'ag-grid-vue': AgGridVue,
    TrainingReportModal,
    Paginator
  },
  props: {
    editMode: Boolean
  },
  data() {
    return {
      shortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Прошлая нед.', value: '-isoWeek' },
        { key: 'last7Days', label: '7 дней', value: 7 },
        { key: 'last30Days', label: '30 дней', value: 30 },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'lastMonth', label: 'Прошлый мес.', value: '-month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' },
        { key: 'lastYear', label: 'Прошлый год', value: '-year' }
      ],
      optionsClass: [
        { value: ['10', '11'], text: 'Все' },
        { value: ['10'], text: '10' },
        { value: ['11'], text: '11' }
      ],
      selectedOrg: null,
      selectedClass: ['10', '11'],
      dateRange: null,
      frameworkComponents: {
        trainingReportRenderer: TrainingReportRenderer,
        dateRangeFilter: DateRangeFilter,
        partialMatchFilter: PartialMatchFilter
      },
      columnDefs: [
        {
          headerName: 'Дата',
          field: 'trainingDate',
          headerClass: 'ag-grid-table-header',
          valueFormatter: dateFormatter,
          sortable: true,
          comparator: notComparator
          // filter: 'dateRangeFilter',
        },
        {
          headerName: 'Ф.И.О.',
          field: 'name',
          headerClass: 'ag-grid-table-header',
          valueFormatter: nameFormatter,
          filter: 'partialMatchFilter',
          sortable: true,
          comparator: notComparator
        },
        {
          headerName: 'Класс',
          field: 'class',
          headerClass: 'ag-grid-table-header',
          valueFormatter: classFormatter
        },
        {
          headerName: 'Этапы',
          field: 'stages',
          headerClass: 'ag-grid-table-header',
          valueFormatter: stagesFormatter
        },
        {
          headerName: 'Роль',
          field: 'role',
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Оценка',
          field: 'mark',
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Отчет',
          field: 'report',
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'trainingReportRenderer'
        }
      ],
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      correctAnswers: [],
      incorrectAnswers: [],
      mark: 0,
      userId: 0
    }
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      hasRole: 'currentUser/hasRole',
      orgs: 'dicts/getOrganizations',
      simulatorMarks: 'educationStudentsManagement/getSimulatorMarks',
      currentPage: 'educationStudentsManagement/getCurrentPage',
      paginationPageSize: 'educationStudentsManagement/getPaginationPageSize',
      total: 'educationStudentsManagement/getTotal',
      pages: 'educationStudentsManagement/getPages'
    }),
    // получаем организации, доступные пользователю (в которых он состоит)
    optionsOrg() {
      if (this.orgs && this.orgs.length) {
        if (this.hasRole('classroom-teacher')) {
          return [{
            value: this.currUser.organizationId,
            text: this.orgs.filter((p) => p.id === this.currUser.organizationId)[0].title
          }]
        }
      }

      return []
    }
  },
  created() {
    this.selectedOrg = this.orgs.filter((p) => p.id === this.currUser.organizationId)[0].id
    this.debouncedFetch({
      classes: this.selectedClass,
      surname: ''
    })
    this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
      this.changePage(1)
      this.debouncedFetch(filters, sorting)
    }, 500)
    this.debouncedFetchSortedData = _.debounce((filters, sorting) => {
      this.debouncedFetch(filters, sorting)
    }, 0)
  },
  beforeDestroy() {
    this.changePage(1)
  },
  methods: {
    ...mapMutations({
      setReportId: 'educationStudentsManagement/setReportId',
      changePage: 'educationStudentsManagement/setCurrentPage'
    }),
    ...mapActions({
      fetchSimulatorMarks: 'educationStudentsManagement/fetchSimulatorMarks'
    }),
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= 1300) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    onGridSizeChanged() {
      if ((this.$refs.gridDiv.clientWidth >= 1300
            && this.$refs.gridDiv.clientWidth > this.gridWidth)
            || (this.$refs.gridDiv.clientWidth >= 1500)) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    getFilteredData() {
      const filters = {}
      filters.classes = this.selectedClass
      const filtersModel = this.gridOptions.api.getFilterModel()
      const surname = filtersModel.name ? filtersModel.name.value : null
      if (surname) {
        filters.surname = surname
      }
      if (this.dateRange && this.dateRange.start && this.dateRange.end) {
        const start = this.dateRange.start.split('.')
        start[1] -= 1
        const end = this.dateRange.end.split('.')
        end[1] -= 1
        filters.date = {
          start: moment(start.reverse()).hour(0).minutes(0).toDate(),
          end: moment(end.reverse()).hour(23).minutes(59).toDate()
        }
      }
      return filters
    },
    getSorting() {
      const sorting = this.gridOptions.api.getSortModel()
      const sortingQuery = []
      sorting.forEach((el) => {
        if (el.colId === 'trainingDate') {
          sortingQuery.push({ date: el.sort.toUpperCase() })
        } else if (el.colId === 'name') {
          sortingQuery.push({ surname: el.sort.toUpperCase() })
        }
      })
      return sortingQuery
    },
    onFilterChanged() {
      this.changePage(1)
      this.debouncedFetchFilteredData(this.getFilteredData(), this.getSorting())
    },
    onSortChanged() {
      this.changePage(1)
      this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
    },
    onParentReportClicked(data) {
      this.setReportId(data.id)
      this.$bvModal.show('trainingReportModal')
    },
    async onPreviousPage() {
      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1)
        this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
      }
    },
    async onNextPage() {
      if (this.currentPage < this.pages) {
        this.changePage(this.currentPage + 1)
        this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
      }
    },
    onToFirstPage() {
      if (this.currentPage > 1) {
        this.changePage(1)
        this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
      }
    },
    onToLastPage() {
      if (this.currentPage < this.pages) {
        this.changePage(this.pages)
        this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
      }
    },
    debouncedFetch(filters, sorting) {
      const payload = {}
      if (filters) {
        payload.filters = filters
      } else {
        payload.filters = ''
      }
      if (sorting) {
        payload.sorting = sorting
      } else {
        payload.sorting = ''
      }
      payload.simulatorId = this.$route.params.trainingId
      this.fetchSimulatorMarks(payload)
    },
    resetFilters() {
      this.dateRange = null
      this.selectedClass = ['10', '11']
      this.gridOptions.api.setFilterModel(null)
      this.gridOptions.api.setSortModel(null)
      this.debouncedFetchSortedData(this.getFilteredData(), this.getSorting())
    }
  }
}
</script>

<style lang="scss" scoped>

.headerButtons {
  width: 100%;
  padding: 20px 0 5px 0;
}

.studentsProgress {

  div {
    margin-top: 15px;
  }

  &__filters {
    width: 100%;

    &-organisation {
      width: 78%;
    }

    &-class {
      float: right;
      width: 20%;
    }

    &-date {
      font-weight: 700;
      font-size: 1.2em;
      display: flex;
      width: 100%;

      &__range {
        display: flex;
        width: 78%;

        &__text {
          padding: 0;
          margin-top: 0 !important;
        }
      }

      &__btn {
        width: 20%;
        margin-left: 30px;

        button {
          width: 100%;
        }
      }
    }
  }

  &__table {
    height: calc(100vh - 380px);
    border-bottom: 1px solid lightgray;
  }

  &__paginator {
    position: relative !important;
    text-align: right !important;
  }

}

.dateRangeFilterButton {
  position: absolute !important;
  right: -100 !important;
  bottom: 0 !important;
}

.custom-button {
  height: 36px !important;
}

</style>
